'use client';

import { useSharedModalAdapterOptional } from '@module/helpers/modal/adapter';
import { useRouter } from 'next/navigation';
import { useRef } from 'react';
import { useRegisterQueryErrorHandler } from './index';
type Props = {
  confirmText: string;
};
export function QueryErrorHandlerBridge({
  confirmText
}: Props) {
  const router = useRouter();
  const modalAdapter = useSharedModalAdapterOptional();
  const adapterRef = useRef(modalAdapter);
  adapterRef.current = modalAdapter;

  // 로그아웃 등으로 여러 쿼리가 동시에 loginMust로 실패하면 모달이 중복 push된다.
  // 모달이 떠있는 동안은 추가 loginMust를 무시하고, 닫힐 때(showConfirm resolve) 다시 허용한다.
  const isLoginMustOpenRef = useRef(false);
  useRegisterQueryErrorHandler((errorCode, error) => {
    switch (errorCode) {
      case 'loginMust':
        {
          if (isLoginMustOpenRef.current) break;
          if (!adapterRef.current) break;
          isLoginMustOpenRef.current = true;
          adapterRef.current?.showConfirm({
            description: error.serverResponse.message,
            confirmText,
            onClose: () => {
              adapterRef.current?.clear();
              router.push('/');
            }
          }).finally(() => {
            isLoginMustOpenRef.current = false;
          });
          break;
        }
    }
  });
  return null;
}